// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"S5-z"};